import React from 'react'

import { BigWidgetWrapper, BigWidgetWrapperWrapperPropTypes } from '../Widget'

import { XlsxValidationByRow } from './types'
import XlsxValidationTable from './XlsxValidationTable'

const XlsxValidatonTableWidget = ({
  list,
  ...props
}: Omit<BigWidgetWrapperWrapperPropTypes, 'children'> & {
  list: XlsxValidationByRow[]
}) => {
  return (
    <BigWidgetWrapper disablePadding withBorder {...props}>
      <XlsxValidationTable
        list={list}
        sx={{
          height: '100%',
          width: '100%',
          boxShadow: 'none',
          borderRadius: (theme) => theme.spacing(0.5),
        }}
      />
    </BigWidgetWrapper>
  )
}

export default XlsxValidatonTableWidget
